import {isBrandPortal} from '@netx/core/utils';
import {type IAsset} from '../schema';
import {canCreateShareLinkFromAsset} from './canCreateShareLinkFromAsset';

export const canCreateEmbedLinkFromAsset = (asset?: IAsset) =>
	canCreateShareLinkFromAsset(asset);

export default canCreateEmbedLinkFromAsset;
